/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ baseName: NonNullable<unknown> }} Free_Open_Bird_VersionInputs */

const en_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Free`)
};

const id_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Gratis`)
};

const ms_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Percuma`)
};

const ca_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} gratuït`)
};

const cs_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} zdarma`)
};

const da_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gratis ${i?.baseName}`)
};

const de_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} kostenlos`)
};

const et_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Free`)
};

const es_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} gratis`)
};

const fr_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version gratuite ${i?.baseName}`)
};

const hr_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} – besplatno`)
};

const it_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} gratuito`)
};

const lv_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName}: bezmaksas`)
};

const lt_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName}: nemokama`)
};

const hu_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Ingyenes`)
};

const nl_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Gratis`)
};

const nb_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Free`)
};

const pl_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} – za darmo`)
};

const pt_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} grátis`)
};

const ro_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Gratuit`)
};

const sk_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Zadarmo`)
};

const sl_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`»${i?.baseName}« brezplačno`)
};

const fi_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Ilmainen`)
};

const sv_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} gratis`)
};

const vi_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Miễn phí`)
};

const tr_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Ücretsiz`)
};

const el_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Δωρεάν`)
};

const bg_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} безплатно`)
};

const ru_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Бесплатно`)
};

const sr_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Нема ${i?.baseName}`)
};

const uk_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} Безкоштовно`)
};

const ka_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} უფასო`)
};

const hi_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} फ्री`)
};

const th_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} ฟรี`)
};

const ko_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} 무료`)
};

const zh_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`免费 ${i?.baseName}`)
};

const zh_tw_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} 免費`)
};

const ja_free_open_bird_version = /** @type {(inputs: Free_Open_Bird_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseName} 無料`)
};

/**
* | output |
* | --- |
* | "{baseName} Free" |
*
* @param {Free_Open_Bird_VersionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const free_open_bird_version = /** @type {((inputs: Free_Open_Bird_VersionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Open_Bird_VersionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_free_open_bird_version(inputs)
	if (locale === "ms") return ms_free_open_bird_version(inputs)
	if (locale === "ca") return ca_free_open_bird_version(inputs)
	if (locale === "cs") return cs_free_open_bird_version(inputs)
	if (locale === "da") return da_free_open_bird_version(inputs)
	if (locale === "de") return de_free_open_bird_version(inputs)
	if (locale === "et") return et_free_open_bird_version(inputs)
	if (locale === "es") return es_free_open_bird_version(inputs)
	if (locale === "fr") return fr_free_open_bird_version(inputs)
	if (locale === "hr") return hr_free_open_bird_version(inputs)
	if (locale === "it") return it_free_open_bird_version(inputs)
	if (locale === "lv") return lv_free_open_bird_version(inputs)
	if (locale === "lt") return lt_free_open_bird_version(inputs)
	if (locale === "hu") return hu_free_open_bird_version(inputs)
	if (locale === "nl") return nl_free_open_bird_version(inputs)
	if (locale === "nb") return nb_free_open_bird_version(inputs)
	if (locale === "pl") return pl_free_open_bird_version(inputs)
	if (locale === "pt") return pt_free_open_bird_version(inputs)
	if (locale === "ro") return ro_free_open_bird_version(inputs)
	if (locale === "sk") return sk_free_open_bird_version(inputs)
	if (locale === "sl") return sl_free_open_bird_version(inputs)
	if (locale === "fi") return fi_free_open_bird_version(inputs)
	if (locale === "sv") return sv_free_open_bird_version(inputs)
	if (locale === "vi") return vi_free_open_bird_version(inputs)
	if (locale === "tr") return tr_free_open_bird_version(inputs)
	if (locale === "el") return el_free_open_bird_version(inputs)
	if (locale === "bg") return bg_free_open_bird_version(inputs)
	if (locale === "ru") return ru_free_open_bird_version(inputs)
	if (locale === "sr") return sr_free_open_bird_version(inputs)
	if (locale === "uk") return uk_free_open_bird_version(inputs)
	if (locale === "ka") return ka_free_open_bird_version(inputs)
	if (locale === "hi") return hi_free_open_bird_version(inputs)
	if (locale === "th") return th_free_open_bird_version(inputs)
	if (locale === "ko") return ko_free_open_bird_version(inputs)
	if (locale === "zh") return zh_free_open_bird_version(inputs)
	if (locale === "zh-tw") return zh_tw_free_open_bird_version(inputs)
	if (locale === "ja") return ja_free_open_bird_version(inputs)
	return en_free_open_bird_version(inputs)
});